const config = {
  zc: {},
  //gmapi: "http://localhost:5000",
  gmapi: "https://api.stormhavenstudios.com",
  gameapi: "https://game-api.stormhavenstudios.com",
  flagTxt: function (flags) {
    if ((flags & 1) == 0) {
      return 'Offline';
    }

    if (flags == 1) {
      return 'Open';
    }

    return 'Restricted';
  },
  flagClr: function (flags) {
    if ((flags & 1) == 0) {
      return 'light';
    }

    if (flags == 1) {
      return 'success';
    }

    return 'warning';
  },
  statusTxt: function (active) {
    return active ? "Online" : "Offline";
  },
  statusClr: function (active) {
    return active ? "success" : "light"
  },
  userTxt: function (flags) {
    return (flags & 1) == 0 ? "Disabled" :
      (flags & 2) == 2 ? "GM" :
        (flags & 4) == 4 ? "Dev+" :
          (flags & 8) == 8 ? "Streamer" :
            flags & 1 ? "Active" :
              "Unknown";
  },
  userClr: function (flags) {
    return (flags & 1) == 0 ? "dark" :
      (flags & 2) == 2 ? "info" :
        (flags & 4) == 4 ? "warning" :
          (flags & 8) == 8 ? "secondary" :
            flags & 1 ? "primary" :
              "danger";
  },
  subTxt: function (stat) {
    return !stat ? "NA" :
      stat == "TOP" ? "Active" :
        stat == "CAN" ? "Canceled" :
          "InActive";
  },
  subClr: function (stat) {
    return !stat ? "dark" :
      stat == "TOP" ? "primary" :
        stat == "CAN" ? "danger" :
          "info";
  },
  getHeaders: function () {
    return {
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': 'Bearer ' + localStorage.jwt
    };
  }
};

config.zc['qa'] = "https://emb-03.embersadrift.com:2090";
config.zc['live'] = "https://emb-tx-fe-01.stormhavenstudios.com:2090";

export { config };
export default config;
